module.exports = __webpack_public_path__ + "static/juan-domingo-peron-mn.44619605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/juan-domingo-peron-mn.jpg
// module id = 73
// module chunks = 168707334958949